import { escapeCsvCell } from "./csvFileHelpers";
import { formatTimestampForTable } from "./dateDisplay";
import { formatPhoneDisplay } from "./phoneFormat";
import { isPlaceholderEmail } from "./displayEmail";
import {
  formatOpportunityDuration,
  getVolunteerParticipantDisplayName,
  normalizeVolunteerOpportunityStatus,
} from "./volunteerOpportunityDisplay";

export const VOLUNTEER_PARTICIPANT_CSV_HEADER_LABELS = [
  "Participant",
  "Email",
  "Phone",
  "Signed up",
  "Opportunity",
  "Volunteering Hours",
  "Category",
  "Status",
];

export const VOLUNTEER_PARTICIPANT_CSV_HEADER_LINE = VOLUNTEER_PARTICIPANT_CSV_HEADER_LABELS.join(",");

/** @param {Record<string, unknown>} row */
export function volunteerParticipantRowToCsvCells(row) {
  const emailRaw = row?.email != null ? String(row.email).trim() : "";
  return [
    getVolunteerParticipantDisplayName(row),
    emailRaw && !isPlaceholderEmail(emailRaw) ? emailRaw : "",
    row?.phone ? formatPhoneDisplay(row.phone) : "",
    formatTimestampForTable(row?.signup_date),
    row?.opportunity_name != null ? String(row.opportunity_name).trim() : "",
    formatOpportunityDuration(row?.opportunity_start_datetime, row?.opportunity_end_datetime),
    row?.opportunity_category != null ? String(row.opportunity_category).trim() : "",
    normalizeVolunteerOpportunityStatus(row?.opportunity_status),
  ];
}

/**
 * @param {Record<string, unknown>[]} rows
 * @returns {string}
 */
export function buildVolunteerParticipantCsvExportText(rows) {
  const list = Array.isArray(rows) ? rows : [];
  const lines = [
    VOLUNTEER_PARTICIPANT_CSV_HEADER_LINE,
    ...list.map((row) => volunteerParticipantRowToCsvCells(row).map(escapeCsvCell).join(",")),
  ];
  return lines.join("\r\n");
}
